import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import TokenPair from '@square/dashboard-data/models/squareup/common/token/token-pair';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
import { ItemizationGroup } from '@square/dashboard-protos/models/squareup/bills/cart';

// NB: POJOs listed below can still be accessed, but attributes won't be camelized
// and they won't update automatically in computed properties

const ComboChoice = ProtoBaseModel.extend({
  comboChoiceId: attr(String),
  name: attr(String),
  validationDetails: attr(Object),
  // POJO for now
  clientToken: attr(String)
});
const ReadOnlyDisplayDetails = ProtoBaseModel.extend({
  name: attr(String),
  variationName: attr(String),
  comboChoices: repeated(ComboChoice),
  itemVariationPriceMoney: attr(MoneyProto),
  note: attr(String)
});
export default ProtoBaseModel.extend({
  itemizationGroupTokenPair: attr(TokenPair),
  itemizationClientTokens: repeated(String),
  type: attr(ItemizationGroup.Type),
  writeOnlyBackingDetails: attr(Object),
  // POJO for now
  readOnlyDisplayDetails: attr(ReadOnlyDisplayDetails)
});